import {
  Badge,
  Box,
  Grid,
  Typography,
  styled,
  Avatar as Muiavatar,
} from "@mui/material";
import React, { useMemo } from "react";

import "./history.scss";
import Avatar from "../../../../../../components/Avatar";
import CustomDateFormatter from "../../../../../../utils/dateTimeFormatter";
import { createAvatarName, hasImage, SanitizedHtml } from "../../../../../../utils";
import HistoryIcon from "../../../../../../styles/svg/history-icon.svg";
import { useResponsive } from "../../../../../../hooks/useResponsive";
import EventDetails from "./EventDetails";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

const SmallAvatar = styled(Muiavatar)(({ theme }) => ({
  width: 16,
  height: 16,
  border: `2px solid ${theme.palette.background.paper}`,
}));
function HistoryItem({ history, showIcon = false }) {
  const isMobile = useResponsive("down", "md");
  const isBetween300And699 = useResponsive("between", 300, 699);

  const avatarStyle = useMemo(() => ({
    height: "32px",
    width: "32px",
    ...(!hasImage(history?.response_object?.user_object?.user_image) && {
      bgcolor: history?.response_object?.user_object?.profile_color?.background,
      color: history?.response_object?.user_object?.profile_color?.background.text,
    }),
  }), [history?.response_object?.user_object]);

  const avatarContent = useMemo(() =>
    createAvatarName(history?.response_object?.user_object?.username || ""),
    [history?.response_object?.user_object?.username]
  );

  const dateFormatter = useMemo(() => (
    <CustomDateFormatter date={history.at_time} />
  ), [history.at_time]);

  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          px: isMobile && "",
          pl: isMobile ? 1 : "",
          width: isMobile ? "96%" : "100%",
        }}>
        <Grid container spacing={2} className="history-container">
          <div
            className="worklog-box"
            style={{ width: isMobile ? "100%" : "" }}>
            <Grid>
              {showIcon ? (
                <Badge
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  badgeContent={
                    <SmallAvatar alt="Remy Sharp" src={HistoryIcon} />
                  }>
                  <Avatar
                    user_image={
                      history?.response_object?.user_object?.user_image
                    }
                    title={history?.response_object?.user_object?.username}
                    style={avatarStyle}
                    className={" header-avatar"}>
                    {avatarContent}
                  </Avatar>
                </Badge>
              ) : (
                <Avatar
                  user_image={history?.response_object?.user_object?.user_image}
                  title={history?.response_object?.user_object?.username}
                  style={avatarStyle}
                  className={" header-avatar"}>
                  {avatarContent}
                </Avatar>
              )}
            </Grid>
            <div
              className="worklog-box-body"
              style={{ width: isMobile ? "100%" : "" }}>
              <div className="d-flex">
                <Grid sx={{ width: "100%" }}>
                  <div className="d-flex justify-content-space-between">
                    <SanitizedHtml
                      as="div"
                      html={history.history_text}
                      className={isMobile ? "mobile-font" : ""}
                    />
                    {isBetween300And699 ? (
                      ""
                    ) : (
                      <Typography className="worklog-box-date">
                        <div className="worklog-box-date-field">
                          {/* <CustomDateFormatter date={history.at_time} /> */}
                          {dateFormatter}
                        </div>
                      </Typography>
                    )}
                  </div>

                  {/* {history?.response_object?.old_key && <div className="d-flex align-items-center mt-2">
                    <p>{result}</p>
                    <ArrowRightAltIcon className="ml-3 mr-3" />
                    <p>{history?.response_object?.new_key}</p>
                  </div>} */}

                  <div>
                    {history.response_object && (
                      <EventDetails
                        eventType={history.response_object?.event_type}
                        responseObject={history.response_object}
                        isMobile={isMobile}
                      />
                    )}
                  </div>
                </Grid>
              </div>
              {isBetween300And699 ? (
                <Typography className="worklog-box-date opacity-50">
                  <div>
                    {dateFormatter}
                  </div>
                </Typography>
              ) : (
                ""
              )}
            </div>
          </div>
        </Grid>
      </Box>
    </>
  );
}

export default React.memo(HistoryItem);
